import React, { useRef, useState, useEffect } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Select,
  DatePicker,
  Space,
  Form,
  message,
} from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getSelectedDepartmentId,
  getShiftTimeMaster,
  getUserList,
  getClientid,
  getUserInfo,
  getWeekendShifts,
  getShiftList,
} from "redux/selectors";
import { utils, writeFileXLSX } from "xlsx";
import { CALL_API } from "common/API";
import { MONTH_LIST, STATUS_CODE } from "common/Constants";

import {
  addDaysinDate,
  dateInDetail,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  isDateBetweenTwoDates,
  momentDate,
  numberOfDaysBetweenDates,
} from "utils/Date";
import COLORS from "common/Colors";
import {
  concat,
  find,
  get,
  includes,
  orderBy,
  flatMap,
  intersection,
  reduce,
} from "lodash";
import { ButtonOutlined } from "reusableComponent/UIButtons";

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-select-selector {
    max-width: 180px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 180px;
  }
`;
const StyledButtonoutlined = styled(ButtonOutlined)`
  @media (max-width: 900px) {
    margin-left: -20px !important;
  }
  @media (max-width: 768px) {
    margin-left: -20px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;
function MonthlyAttendanceReport({
  userRoleId,
  allDepartmentList,
  selectedDepartmentId,
  ClientId,
  userList,
  userInfo,
  weekendShifts,
  shiftList,
}) {
  const higherOfficialsEmailId = userInfo?.higherOfficialsList?.map(
    (val) => val.email
  );

  // const [weekendShiftUser, setWeekendShiftUser] = useState()

  // const FindShiftUser = userList?.find((item) => item.userid === userInfo?.userid)
  //   console.log("FindShiftUserMonth121--->", FindShiftUser);
  // useEffect(() => {
  //   setWeekendShiftUser(FindShiftUser?.weekendShift)
  // }, [FindShiftUser])
  // console.log("weekendShiftUserMonth--->", weekendShiftUser);

  // console.log("higherOfficialsEmailId-->", higherOfficialsEmailId);
  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [attendanceList, setAttendanceList] = useState([]);
  console.log("attendanceList-->", attendanceList);
  const [CSVAttendanceList, setCSVAttendanceList] = useState([]);
  const [form] = Form.useForm();
  const csvLinkEl = useRef();
  var filterList = [];
  const [CSVList, setCSVList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const containerRef = useRef(null);

  const curr_month = moment().month() + 1;

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(month_list);
  };

  const STAFF_LIST_ALL = attendanceList.map((val) => {
    return { userId: val.userid, fullName: val.fullname };
  });

  for (let i = 0; i < STAFF_LIST_ALL.length; i++) {
    filterList.push(STAFF_LIST_ALL[i]);
  }

  const STAFF_LIST = [...new Set(filterList.map((a) => JSON.stringify(a)))].map(
    (a) => JSON.parse(a)
  );

  const filterattentancereport = attendanceList.filter((val) => {
    if (form.getFieldValue("staff_name") === "") {
      return val;
    } else if (val?.userid === form.getFieldValue("staff_name")) {
      return val;
    }
  });

  const [holidayList, setHolidayList] = useState([]);

  const calculateSundays = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);

    let sundays = 0;
    let currentDay = start.clone();

    while (currentDay.isSameOrBefore(end, "day")) {
      if (currentDay.day() === 0) {
        sundays++;
      }
      currentDay.add(1, "day");
    }

    return sundays;
  };

  // const workingdays = async (startDate, endDate, userId, holidayLists) => {
  //   const totalDay = numberOfDaysBetweenDates(startDate, endDate) + 1
  //   const filterUser = userList?.filter((val) => val?.userid === userId)
  //   const holidayPerUser = holidayLists?.filter((item) => item?.location_id?.includes(filterUser[0]?.baselocationid))
  //   let totalHolidays = 0;
  //   holidayPerUser.forEach(holiday => {
  //     const removeSundays = calculateSundays(holiday.start_date, holiday.end_date);
  //     totalHolidays += numberOfDaysBetweenDates(holiday.start_date, holiday.end_date) + 1 - removeSundays;
  //   });

  //   const sundayCount = calculateSundays(startDate, endDate);

  //   return totalDay - (sundayCount + totalHolidays)

  // };

  const workingdays = async (
    startDate,
    endDate,
    userId,
    holidayLists,
    assignedShiftList
  ) => {
    const filterUserShift = assignedShiftList?.filter(
      (item) => item?.userId === userId
    );

    const filterUser = userList?.filter((val) => val?.userid === userId);
    const holidayPerUser = holidayLists?.filter((item) =>
      item?.location_id?.includes(filterUser[0]?.baselocationid)
    );

    const filterShifts = filterUserShift.flatMap((shift) => shift?.dates);

    const count = filterShifts.filter((item) => {
      const date = moment(item.date, "YYYY-MM-DD");

      const isHoliday = find(holidayPerUser, ({ start_date, end_date }) =>
        isDateBetweenTwoDates(date, start_date, end_date)
      );

      const findShift = shiftList?.find(
        (val) => val?.shift_id === item?.shift_id
      );
      const weekend =
        (findShift?.isweekend === "allsaturdayandsunday" &&
          (moment(date).day() === 0 || moment(date).day() === 6)) ||
        (findShift?.isweekend === "allsaturdays" && moment(date).day() === 6) ||
        (findShift?.isweekend === "allsundays" && moment(date).day() === 0) ||
        findShift?.isweekend === "alldays" ||
        (isHoliday && findShift?.isholiday === "yes");

      return (
        date.isSameOrAfter(startDate) &&
        date.isSameOrBefore(endDate) &&
        !weekend
      );
    }).length;

    return count;
  };

  // Helper function to calculate the number of Saturdays and Sundays between two dates
  // const calculateWeekends = (start, end, weekendShiftUser) => {
  //   console.log("weekendShiftUserchweck--->", weekendShiftUser)
  //   let weekendCount = 0;
  //   let okayData = 0;
  //   const currentDate = new Date(start);
  //   const endDate = new Date(end);
  //   console.log("endDate121--->", currentDate, endDate)
  //   // New Code
  //   const isSaturdayNotApplicable =
  //     weekendShiftUser?.saturdayEnabled === true &&
  //     weekendShiftUser?.notApplicable === false;

  //   const isSundayNotApplicable =
  //     weekendShiftUser?.sundayEnabled === true &&
  //     weekendShiftUser?.notApplicable === false;
  //   // const isSaturdayNotApplicable =
  //   //   weekendShiftUser?.saturdayEnabled === false ||
  //   //   weekendShiftUser?.saturdayType === "NotApplicable";
  //   // const isSundayNotApplicable =
  //   //   weekendShiftUser?.sundayEnabled === false ||
  //   //   weekendShiftUser?.sundayType === "NotApplicable";
  //   console.log("isSaturdayNotApplicable-->", isSaturdayNotApplicable)
  //   console.log("isSundayNotApplicable-->", isSundayNotApplicable)
  //   while (currentDate <= endDate) {
  //     const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 6 = Saturday
  //     console.log("dayOfWeek--->", dayOfWeek)
  //     if (dayOfWeek === 6) {
  //       if(isSundayNotApplicable){
  //         weekendCount++;
  //       }else{
  //         okayData++
  //       }
  //     } else if (dayOfWeek === 0) {
  //       if(isSundayNotApplicable){
  //         weekendCount++;
  //       }else{
  //         okayData++
  //       }
  //       // weekendCount++;
  //     }
  //     currentDate.setDate(currentDate.getDate() + 1);
  //   }
  //   console.log("weekendCount121--->", weekendCount)
  //   console.log("okayData121---->", okayData)
  //   return okayData - weekendCount;
  // };

  // New Change code
  // const calculateWeekends = (start, end, weekendShiftUser) => {
  //   let weekendCount = 0;
  //   let totalWeekendCount = 0;
  //   // const currentDate = new Date(start);
  //   // const endDate = new Date(end);
  //   const startDate = new Date(start);
  //   const endDate = new Date(end);
  //   let currentDate = new Date(startDate);

  //   const isSaturdayNotApplicable =
  //     weekendShiftUser?.saturdayEnabled === true &&
  //     weekendShiftUser?.notApplicable === false;

  //   const isSundayNotApplicable =
  //     weekendShiftUser?.sundayEnabled === true &&
  //     weekendShiftUser?.notApplicable === false;
  //   console.log("isSaturdayNotApplicable121--->", isSaturdayNotApplicable)
  //   console.log("isSundayNotApplicable121--->", isSundayNotApplicable)
  //   while (currentDate <= endDate) {
  //     const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 6 = Saturday

  //     if (dayOfWeek === 6) {
  //       if (isSaturdayNotApplicable) {
  //         if (weekendShiftUser?.saturdayType === "halfday") {
  //           console.log("chek1--->", dayOfWeek)
  //           weekendCount += 0.5;
  //         } else if (weekendShiftUser?.saturdayType === "fullday") {
  //           console.log("chek2--->", dayOfWeek)
  //           weekendCount += 1;
  //         }
  //       }
  //       totalWeekendCount++;
  //     }

  //     // Sunday
  //     else if (dayOfWeek === 0) {
  //       if (isSundayNotApplicable) {
  //         if (weekendShiftUser?.sundayType === "halfday") {
  //           weekendCount += 0.5;
  //         } else if (weekendShiftUser?.sundayType === "fullday") {
  //           weekendCount += 1;
  //         }
  //       }
  //       totalWeekendCount++;
  //     }

  //     currentDate.setDate(currentDate.getDate() + 1);
  //   }
  //   console.log("weekendCount121--->", weekendCount)
  //   console.log("okayData121---->", totalWeekendCount)
  //   return totalWeekendCount - weekendCount;
  // };

  const calculateWeekends = (start, end, weekendShiftUser) => {
    let weekendCount = 0;
    let totalWeekendCount = 0;
    const startDate = new Date(start);
    const endDate = new Date(end);
    let currentDate = new Date(startDate); // ← proper clone for looping

    const isSaturdayNotApplicable =
      weekendShiftUser?.saturdayEnabled === true &&
      weekendShiftUser?.notApplicable === false;

    const isSundayNotApplicable =
      weekendShiftUser?.sundayEnabled === true &&
      weekendShiftUser?.notApplicable === false;

    // console.log("isSaturdayNotApplicable121--->", isSaturdayNotApplicable);
    // console.log("isSundayNotApplicable121--->", isSundayNotApplicable);

    while (currentDate <= endDate) {
      const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 6 = Saturday

      if (dayOfWeek === 6) {
        // Saturday
        if (isSaturdayNotApplicable) {
          if (weekendShiftUser?.saturdayType === "halfday") {
            // console.log("Saturday halfday --->", currentDate);
            weekendCount += 0.5;
          } else if (weekendShiftUser?.saturdayType === "fullday") {
            // console.log("Saturday fullday --->", currentDate);
            weekendCount += 1;
          }
        }
        totalWeekendCount++;
      } else if (dayOfWeek === 0) {
        // Sunday
        if (isSundayNotApplicable) {
          if (weekendShiftUser?.sundayType === "halfday") {
            // console.log("Sunday halfday --->", currentDate);
            weekendCount += 0.5;
          } else if (weekendShiftUser?.sundayType === "fullday") {
            // console.log("Sunday fullday --->", currentDate);
            weekendCount += 1;
          }
        }
        totalWeekendCount++;
      }

      // Safely move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }

    // console.log("weekendCount121--->", weekendCount);
    // console.log("okayData121---->", totalWeekendCount);

    return totalWeekendCount - weekendCount;
  };

  const CSVHeaders = [
    { label: "Employee ID" },
    { label: "User ID" },
    { label: "First Name" },
    { label: "Last Name" },
    // Note : this code need in future
    // { label: "Department" },
    { label: "Total Working Days" },
    { label: "Worked days" },
    { label: "On-time" },
    { label: "Late" },
    { label: "Leave" },
    { label: "Absent" },
  ];
  const prepareCSV = async (event, done) => {
    if (filterattentancereport.length > 0) {
      setCSVList(
        reduce(
          filterattentancereport,
          (result, report) => {
            // Calculating total working days and worked days
            const workedDays =
              (report.ontimecount || 0) + (report.latecount || 0);

            // Pushing the structured data to the result array
            result.push({
              "Employee ID": report.employeeid || "-",
              "User ID": report.userid || "-",
              Name: report.fullname || "-",
              "Total Working days": report.totalWorkingDays || "0",
              "Worked days": workedDays,
              "On-Time": report.ontimecount ?? "0",
              Late: report.latecount ?? "0",
              Leave: report.leavecount ?? "0",
              Absent: report.absentcount ?? "0",
            });

            return result;
          },
          []
        )
      );

      // Trigger download after setting CSV data
      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error("No data available to download.");
    }
  };
  const columns = [
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: 130,
    },
    {
      title: "User ID",
      dataIndex: "userid",
      key: "userid",
      width: 270,
      render: (userid) => {
        if (userid !== ("" || null || undefined)) {
          return userid;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: 170,
      render: (fullname) => {
        if (fullname !== ("" || null || undefined)) {
          return fullname;
        } else {
          return "-";
        }
      },
    },

    {
      title: "Total Working days",
      dataIndex: "totalWorkingDays",
      key: "totalWorkingDays",
      width: 170,
    },
    {
      title: "Worked days",
      dataIndex: "workingDays",
      key: "workingDays",
      width: 150,
      render: (_, record) => {
        if (record.ontimecount || record.latecount) {
          return record.ontimecount + record.latecount;
        } else {
          return 0;
        }
      },
    },

    {
      title: "On-Time",
      dataIndex: "ontimecount",
      key: "ontimecount",
      width: 100,
      render: (onTimeCount) => {
        if (onTimeCount === ("" || null || undefined)) {
          return "0";
        } else {
          return onTimeCount;
        }
      },
    },
    {
      title: "Late",
      dataIndex: "latecount",
      key: "latecount",
      width: 100,
      render: (lateCount) => {
        if (lateCount === ("" || null || undefined)) {
          return "0";
        } else {
          return lateCount;
        }
      },
    },

    {
      title: "Leave",
      dataIndex: "leavecount",
      key: "leavecount",
      width: 100,
      render: (leaveCount) => {
        if (leaveCount === ("" || null || undefined)) {
          return "0";
        }
        const num = parseFloat(leaveCount);
        if (isNaN(num)) {
          return "0";
        }
        return num.toString();
      },
    },
    {
      title: "Absent",
      dataIndex: "absentcount",
      key: "absentcount",
      width: 100,
      render: (absentCount) => {
        if (absentCount === ("" || null || undefined)) {
          return "0";
        } else {
          return absentCount;
        }
      },
    },
  ];

  useEffect(() => {
    getAttendanceReport();
  }, [
    selectedDepartmentId,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
  ]);

  // Function to generate report
  const getAttendanceReport = async () => {
    list();
    setAttendanceList([]);
    const { month, department } = form.getFieldsValue();
    setDisplayTableLoader(true);

    const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
      dateInDetail(getKenyanDateTime()).year,
      get(find(MONTH_LIST, { value: month }), "index", 0)
    );

    const getAssignedShiftList = async () => {
      try {
        const { data } = await CALL_API(
          `get-assigned-shift/${ClientId}`,
          "post",
          {
            from: getMySqlDate(startDateOfMonth),
            to: getMySqlDate(lastDateOfMonth),
          }
        );
        return data || [];
      } catch (error) {
        console.log("[getAssignedShiftList] Error:", error);
        return [];
      }
    };

    const assignedShiftList = await getAssignedShiftList();

    const holidayLists = await CALL_API(`holiday-list/${ClientId}`, "post", {
      start_date: getMySqlDate(startDateOfMonth),
      end_date: getMySqlDate(lastDateOfMonth),
    });

    if (holidayLists) {
      setHolidayList(holidayLists);
    }

    const { code, monthlyAttendanceList } = await CALL_API(
      `attendance-report-monthly/${ClientId}`,
      "post",
      {
        departmentId: [""],
        startDate: getMySqlDate(startDateOfMonth),
        endDate: getMySqlDate(lastDateOfMonth),
        reportingmanager: userInfo?.userid,
      }
    );

    if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
      const userIdExistsInData1 = (userId) => {
        if (!userId) return false; // Ensure userId is valid
        return monthlyAttendanceList?.some(
          (item) => item?.userid?.toLowerCase() === userId.toLowerCase()
        );
      };
      console.log("userList-->", userList);
      const allUserList =
        // higherOfficialsEmailId?.includes(userInfo?.userid)
        //   ? userList?.filter((item) => {
        //       const userId = item?.userid?.toLowerCase();
        //       return (
        //         userId && item?.statusid === "1" && !userIdExistsInData1(userId)
        //       );
        //     })
        //   : userList
        //       ?.filter((item) => {
        //         const userId = item?.userid?.toLowerCase();
        //         return (
        //           userId &&
        //           item?.statusid === "1" &&
        //           !userIdExistsInData1(userId) &&
        //           item?.reportingmanager === userInfo?.userid
        //         );
        //       })
        userList
          ?.filter((item) => {
            const userId = item?.userid?.toLowerCase();
            return (
              userId &&
              item?.statusid === "1" &&
              item?.reportingmanager === userInfo?.userid &&
              !userIdExistsInData1(userId)
            );
          })
          .map((item) => ({
            employeeid: item?.employeeid,
            latecount: 0,
            monthenddate: getMySqlDate(lastDateOfMonth),
            leavecount: 0,
            userid: item?.userid,
            monthstartdate: getMySqlDate(startDateOfMonth),
            absentcount: 0,
            earlycheckoutcount: 0,
            fullname: item?.fullname,
            ontimecount: 0,
          }));

      // const isHigherOfficial = higherOfficialsEmailId?.includes(
      //   userInfo?.userid
      // );

      // const filteredUserList = userList?.filter((item) => {
      //   const userId = item?.userid?.toLowerCase();
      //   const isValid =
      //     userId &&
      //     item?.statusid === "1" &&
      //     !userIdExistsInData1(userId) &&
      //     (isHigherOfficial || item?.reportingmanager === userInfo?.userid);
      //   return isValid;
      // });

      // const allUserList = filteredUserList?.map((item) => ({
      //   employeeid: item?.employeeid,
      //   latecount: 0,
      //   monthenddate: getMySqlDate(lastDateOfMonth),
      //   leavecount: 0,
      //   userid: item?.userid,
      //   monthstartdate: getMySqlDate(startDateOfMonth),
      //   absentcount: 0,
      //   earlycheckoutcount: 0,
      //   fullname: item?.fullname,
      //   ontimecount: 0,
      // }));

      console.log("allUserList-->", allUserList);

      const monthlyAttendanceReport = concat(
        monthlyAttendanceList,
        allUserList
      );

      await Promise.all(
        monthlyAttendanceReport?.map(async (entry) => {
          const filterUser = userList?.filter(
            (val) => val?.userid === entry?.userid
          );
          const concatenatedArray = flatMap(filterUser[0]?.userdepartmentid);
          const totalWorkingDays = await workingdays(
            moment(entry.monthstartdate)?.format("YYYY-MM-DD"),
            moment(entry.monthenddate)?.format("YYYY-MM-DD"),
            entry.userid,
            holidayLists,
            assignedShiftList
          );
          entry.totalWorkingDays = totalWorkingDays;
          if (
            intersection(concatenatedArray, selectedDepartmentId).length > 0
          ) {
            return entry;
          } else {
            return null;
          }
        })
      );

      // const updatedList = monthlyAttendanceReport?.map(entry => ({
      //   ...entry,
      //   date: new Date(entry.date),
      // }));
      setAttendanceList(monthlyAttendanceReport);
    }
    setDisplayTableLoader(false);
  };

  // Function to validate date range
  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };

  const xport = React.useCallback(() => {
    const elt = document.getElementById("Table");
    const wb = utils.table_to_book(elt);
    writeFileXLSX(wb, "attendance-report.xlsx");
  });

  const [scrollY, setScrollY] = useState();
  useEffect(() => {
    const calculateScrollY = () => {
      // const screenHeight = window.innerHeight;
      // const offset = 180; // Adjust this value as needed for headers/footers
      const dynamicHeight = window.innerHeight - 280;
      setScrollY(dynamicHeight);
    };
    calculateScrollY();
    window.addEventListener("resize", calculateScrollY);
    return () => window.removeEventListener("resize", calculateScrollY);
  }, [scrollY]);

  return (
    <>
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                staff_name: "",
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(getKenyanDateTime()),
                end_date: momentDate(addDaysinDate(getKenyanDateTime(), 7)),
                department: "",
              }}
              onFinish={getAttendanceReport}
            >
              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="Start date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="End date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Form.Item
                        name="month"
                        rules={[
                          {
                            required: true,
                            message: "",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select..."
                          options={monthList}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  );
                }}
              </Form.Item>
              <Form.Item
                name="staff_name"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.fullName ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) => {
                    if (optionA?.userid === "" || optionB?.userid === "") {
                      return 0;
                    }
                    return (optionA?.fullname ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.fullname ?? "").toLowerCase());
                  }}
                  placeholder="Select Employee"
                  options={concat(
                    {
                      userId: "",
                      fullName: "All Employee",
                    },
                    STAFF_LIST
                  )}
                  fieldNames={{
                    label: "fullName",
                    value: "userId",
                  }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
              {(userRoleId === 1 || userRoleId === 6) && (
                <Form.Item name="department">
                  <Select
                    placeholder="Select Department"
                    options={concat(
                      {
                        department_id: "",
                        department_name: "All Departments",
                      },
                      allDepartmentList
                    )}
                    fieldNames={{
                      label: "department_name",
                      value: "department_id",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        <Col xs={24} sm={4} md={4} className="align-right">
          <StyledButtonoutlined
            onClick={prepareCSV}
            disabled={filterattentancereport.length === 0}
          >
            Export CSV file
          </StyledButtonoutlined>
          <CSVLink
            header={CSVHeaders}
            data={CSVList}
            filename={"attendance-report.csv"}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
        </Col>
      </Row>
      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={filterattentancereport}
          columns={columns}
          // Note : First parameter is Needed
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="employeeId"
          scroll={{ y: scrollY }}
          pagination={
            filterattentancereport.length > 100 ? paginationOptions : false
          }
          id="Table"
        />
      </Spin>
      {/* <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={filterattentancereport}
          columns={columns}
          // Note : First parameter is Needed
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          pagination={
            filterattentancereport.length > 100 ? paginationOptions : false
          }
          id="Table"
        />
      </Spin> */}
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  userList: getUserList(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
  weekendShifts: getWeekendShifts(state),
  shiftList: getShiftList(state),
});

export default connect(mapStateToProps, null)(MonthlyAttendanceReport);
